import {
  ListingCostKey,
  ListingCost,
  ListingCostPayableByValues,
  ListingCostPayableAtValues,
} from '@ha/api/v2/types/Listing';

export type CostGroup = 'utility' | 'additional' | 'deposit' | 'optional';

export enum CostGroupValues {
  UTILITY = 'utility',
  ADDITIONAL = 'additional',
  DEPOSIT = 'deposit',
  OPTIONAL = 'optional',
}

export type CostAttribute =
  | 'payableBy'
  | 'payableAt'
  | 'isEstimated'
  | 'required';

export enum CostDefaultOptions {
  TRUE = 'true',
  FALSE = 'false',
  NON_APPLICABLE = 'nonapplicable',
}

export interface CostInput {
  id: ListingCostKey;
  payableBy: ListingCostPayableByValues[];
  payableAt: ListingCostPayableAtValues[];
  required: CostDefaultOptions[];
  refundable: CostDefaultOptions[];
  isEstimated: CostDefaultOptions[];
}

export type CostRecord = ListingCost & {
  id: ListingCostKey;
};

export interface CostRecordErrors {
  id?: string;
  payableBy?: string;
  payableAt?: string;
  required?: string;
  refundable?: string;
  isEstimated?: string;
  value?: string;
}
